// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__j30NA","image":"styles_image__2kKZs","title":"styles_title__3HVjG","button":"styles_button__2pRPe"};